<template>
  <div class="condizioni-generali">
    <div class="default-container default-container-smaller">
      <div v-if="policy" v-html="policy.text"/>
     <script id="CookieDeclaration" src="https://consent.cookiebot.com/a88e3e38-005e-44b9-8030-f79020b541fe/cd.js" type="application/javascript" async></script>
    </div>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import { policy } from '@/queries/policy.js'

export default {
  mixins: [ lang, dataLoad ],
  data: () => ({
    policy: {},
    seo: {}
  }),
  apollo: {
    policy: {
      query: policy,
      fetchPolicy: 'cache-and-network',
      prefetch: true,
      variables () {
        return {
          locale: this.$i18n.locale
        }
      },
      result (result) {
        if (result.data) {
          this.policy = result.data.policy
          this.seo = this.policy.seo
        }
      }
    }
  }
}
</script>
<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .condizioni-generali{
    padding: 12rem 0 14rem;
    background-color: #FFF;

    h1{
      margin-bottom: 1rem;
      margin-top: 2rem;
      @media #{$medium_mq} {
        margin-bottom: 1.5rem;
        margin-top: 2rem;
      }
      @media #{$large_mq} {
        margin-bottom: 2rem;
        margin-top: 2rem;
      }
      @media #{$xlarge_mq} {
        margin-bottom: 3rem;
        margin-top: 3rem;
      }
      @include hero-title(#4A4A4A);
      br{
        display: none;
        @media #{$large_mq} {
          display: none;
        }
      }
    }

    h2{
      padding: 1rem 0 0;
      @media #{$large_mq} {
        padding: 2.5rem 0 0;
        margin-top: 4rem;
      }
      br{
        display: none;
        @media #{$large_mq} {
          display: none;
        }
      }
    }

    h3, h4, h5{
      margin: 0; padding: 2.5rem 0 1rem;
      margin-top: 4rem;
      br{
        display: none;
        @media #{$large_mq} {
          display: none;
        }
      }
    }

    p, li{
      padding: 3rem 0;
      margin: 0;
      line-height: 1.8;
      @media #{$large_mq} {
        line-height: 1.9;
      }
      margin: 0;
    }

    li{
      padding: 0;
      list-style: square;
      list-style-position: inside;
    }

    a{
      color: #37ac8c;
    }

    table{
      border: 1px solid #101010;
      border-collapse: collapse;
      margin: 0;
      padding: 0;
      width: 100%;
      table-layout: fixed;
      margin-top: 30px;
      margin-bottom: 30px;

      tr{
        border: 1px solid #101010;
        padding: .35em;
      }

      th{
        font-size: 1.25rem;
      }

      td, th{
        padding: .9rem;
        vertical-align: top;
        text-align: center;
      }

      td:nth-child(3){
        text-align: left;
      }
    }

  }

</style>
